// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse___tgm3Q","table":"table___1U8eB","string":"string___2Fqbz"};